import React from "react"
import PropTypes from "prop-types"

import Button from "shared/components/Button/Button"

import styles from "./styles.css"

const AutoServicesButton = ({ children, onClick, toLinkBtn }) => {
  if (toLinkBtn) {
    return (
      <div className={styles.buttonLink}>
        <Button toLinkBtn fontWeight="fw-6" onClick={onClick}>
          {children}
        </Button>
      </div>
    )
  }
  return (
    <button className={styles.button} onClick={onClick}>
      {children}
    </button>
  )
}

AutoServicesButton.propTypes = {
  children: PropTypes.string,
  onClick: PropTypes.func,
  toLinkBtn: PropTypes.bool
}
export default AutoServicesButton



// WEBPACK FOOTER //
// ./src/components/AutoServicesButton/index.js